webpackJsonp([5],{

/***/ 154:
/***/ (function(module, exports) {

module.exports = {
  dev: {
    env: 'dev',
    name: '开发环境',
    domain: 'localhost',
    api: 'http://192.168.197.217:7666/',
    community: 'http://localhost:8801',
    platform: 'http://localhost:8800',
    platformData: 'http://localhost:8801/#/statsGateway',
    repair: 'http://192.168.197.217:7666/rfrepairsystem/checkSecurity.xhtml', // 运营数据后台
    device: 'http://192.168.197.217:7666/rfdevicesystem/checkSecurity.xhtml',
    wuye: 'http://192.168.197.217:8022/?action=login',
    kefu: 'http://192.168.197.217:8023/?action=login',
    guard: '', // 安防巡逻
    hr: 'http://192.168.197.217:8025/?action=login', // 已拆分为数据和培训
    pomp: 'http://localhost:8801/#/pompGateway',
    data: 'http://192.168.197.217:8028/?action=login', // 数据管家
    train: 'http://192.168.197.217:8025/?action=login', // 培训管家
    delivery: 'http://192.168.197.217:7666/rfreposystem/checkSecurity.xhtml', // 楼宇交付
    cctv: '', // 视频监控
    ad: '', // 广告平台
    place: '', // 场地管理
  },
  test: {
    env: 'test',
    name: '测试环境',
    domain: 'thinkinpower.net',
    api: 'http://tapi.guanjia.thinkinpower.net/',
    community: 'http://s.zizai.test.thinkinpower.net/',
    platform: 'http://p.zizai.test.thinkinpower.net/',
    jk:'http://s.zizai.test.thinkinpower.net/jk-platform',
    // platformData: 'http://s.zizai.test.thinkinpower.net/#/statsGateway', // 运营数据后台
    // platformData: 'http://stats.zizai.test.thinkinpower.net/#/', // 运营数据后台
    platformData: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=180700&urlPath=http://stats.zizai.test.thinkinpower.net/', // 运营数据后台
    repair: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200100&urlPath=http://tgd.guanjia.thinkinpower.net/rfrepairsystem/index.xhtml', // 工单管家
    device: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200200&urlPath=http://tgd.guanjia.thinkinpower.net/rfdevicesystem/index.xhtml', // 设备管家
    wuye: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200500&urlPath=http://twy.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 物业管家
    kefu: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200600&urlPath=http://tkf.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 客服管家
    guard: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=201000&urlPath=http://txg.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 安防巡逻
    hr: 'http://thr.guanjia.thinkinpower.net/?action=login',
    pomp: 'http://s.zizai.test.thinkinpower.net/#/pompGateway',
    data: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200700&urlPath=http://tbase.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 数据管家
    train: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200800&urlPath=http://tpx.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 培训管家
    delivery: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200300&urlPath=http://tgd.guanjia.thinkinpower.net/rfreposystem/index.xhtml', // 楼宇交付
    cctv: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200900&urlPath=http://tvideo.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 视频监控
    ad: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=201100&urlPath=http://tgd.guanjia.thinkinpower.net/steward-ad/ssoLogin.xhtml', // 广告平台
    place: 'http://p.test.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=201200&urlPath=http://tgd.guanjia.thinkinpower.net/steward-resource/ssoLogin.xhtml', // 场地管理
    corpID: 'wwbed5b3d4eaf1d106', // 企业的CorpID
    agentId: 1000006 // 企业的agentId
  },

  prerelease: {
    env: 'prerelease',
    name: '预发布环境',
    domain: 'thinkinpower.net',
    api: 'http://yapi.guanjia.thinkinpower.net/',
    community: 'http://s.zizai.pre.thinkinpower.net/',
    platform: 'http://p.zizai.pre.thinkinpower.net/',
    jk:'http://s.zizai.test.thinkinpower.net/jk-platform',
    platformData: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=180700&urlPath=http://stats.zizai.pre.thinkinpower.net/', // 运营数据后台
    // platformData: 'http://stats.zizai.pre.thinkinpower.net/#/', // 运营数据后台
    repair: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200100&urlPath=http://ygd.guanjia.thinkinpower.net/rfrepairsystem/index.xhtml', // 工单管家
    device: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200200&urlPath=http://ygd.guanjia.thinkinpower.net/rfdevicesystem/index.xhtml', // 设备管家
    wuye: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200500&urlPath=http://ywy.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 物业管家
    kefu: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200600&urlPath=http://ykf.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 客服管家
    guard: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=201000&urlPath=http://yxg.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 安防巡逻
    hr: 'http://yhr.guanjia.thinkinpower.net/?action=login',
    pomp: 'http://s.zizai.pre.thinkinpower.net/#/pompGateway',
    data: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200700&urlPath=http://base.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 数据管家
    train: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200800&urlPath=http://ypx.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 培训管家
    delivery: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200300&urlPath=http://ygd.guanjia.thinkinpower.net/rfreposystem/index.xhtml', // 楼宇交付
    cctv: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=200900&urlPath=http://yvideo.guanjia.thinkinpower.net/magerlogin/ssoLoginPage', // 视频监控
    ad: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=201100&urlPath=http://ygd.guanjia.thinkinpower.net/steward-ad/ssoLogin.xhtml', // 广告平台
    place: 'http://p.pre.thinkinpower.net/rfInf/checkAppLoginUrl.shtml?appId=201200&urlPath=http://ygd.guanjia.thinkinpower.net/steward-resource/ssoLogin.xhtml', // 场地管理
  },
  prod: {
    env: 'prod',
    name: '',
    domain: 'thinkinpower.com',
    api: 'http://api.guanjia.thinkinpower.com/',
    community: 'http://s.zizai.thinkinpower.com',
    platform: 'http://p.zizai.thinkinpower.com',
    jk:'http://s.zizai.thinkinpower.com/jk-platform',
    platformData: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=180700&urlPath=http://stats.zizai.thinkinpower.com/', // 运营数据后台
    // platformData: 'http://stats.zizai.thinkinpower.com/#/', // 运营数据后台
    repair: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200100&urlPath=http://gd.guanjia.thinkinpower.com/rfrepairsystem/index.xhtml', // 工单管家
    device: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200200&urlPath=http://gd.guanjia.thinkinpower.com/rfdevicesystem/index.xhtml', // 设备管家
    wuye: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200500&urlPath=http://wy.guanjia.thinkinpower.com/magerlogin/ssoLoginPage', // 物业管家
    kefu: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200600&urlPath=http://kf.guanjia.thinkinpower.com/magerlogin/ssoLoginPage', // 客服管家
    guard: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=201000&urlPath=http://xg.guanjia.thinkinpower.com/magerlogin/ssoLoginPage', // 安防巡逻
    hr: 'http://hr.guanjia.thinkinpower.com/?action=login',
    pomp: 'http://s.zizai.thinkinpower.com/#/pompGateway',
    data: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200700&urlPath=http://base.guanjia.thinkinpower.com/magerlogin/ssoLoginPage', // 数据管家
    train: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200800&urlPath=http://px.guanjia.thinkinpower.com/magerlogin/ssoLoginPage', // 培训管家
    delivery: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200300&urlPath=http://gd.guanjia.thinkinpower.com/rfreposystem/index.xhtml', // 楼宇交付
    cctv: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=200900&urlPath=http://video.guanjia.thinkinpower.com/magerlogin/ssoLoginPage', // 视频监控
    ad: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=201100&urlPath=http://gd.guanjia.thinkinpower.com/steward-ad/ssoLogin.xhtml', // 广告平台
    place: 'http://p.thinkinpower.com/rfInf/checkAppLoginUrl.shtml?appId=201200&urlPath=http://gd.guanjia.thinkinpower.com/steward-resource/ssoLogin.xhtml', // 场地管理
    corpID: 'ww1813e1da41715908', // 企业的CorpID
    agentId: 1000003 // 企业的agentId
  },
};

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_env_conf__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_env_conf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_env_conf__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  // Here to customize your router's actions.
  window.scrollTo(0, 0);

  var isLogin = __WEBPACK_IMPORTED_MODULE_3__vuex__["a" /* default */].getters.isLogin;
  if (!isLogin && to.path !== '/login') {
    next({ path: '/login', replace: true });
  } else {
    next();
  }
});


__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__vuex__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$env = __WEBPACK_IMPORTED_MODULE_7__config_env_conf___default.a['test'];

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__vuex__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_footer__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    cFooter: __WEBPACK_IMPORTED_MODULE_0__components_footer___default.a
  },
  created: function created() {
    var _this = this;

    this.$store.watch(function (_ref) {
      var loginStatus = _ref.loginStatus;

      if (loginStatus === null) {
        _this.$router.replace('login');
        location.reload();
      }
    });
  }
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




/**
 * Created by chenguangjun on 2016/9/1.
 */

var cookieHandle = function () {
  // To handle a cookie
  function cookieHandle(key) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, cookieHandle);

    this.key = key.toString();
    this.content = this.get(); // If the cookie exists, get the content. Otherwise, leave it null.
    return this.content;
  }

  // validTime is millisecond


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(cookieHandle, [{
    key: 'set',
    value: function set(content) {
      var validTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 360 * 24 * 60 * 60 * 1000;
      var domain = arguments[2];
      // Set cookie
      if (typeof parseInt(validTime) !== 'number' || validTime < 0) {
        // Restrict
        validTime = 360 * 24 * 60 * 60 * 1000; // Available for 360 days
      }
      var expireTime = new Date(Date.now() + validTime);

      var cookie = this.key + '=' + encodeURIComponent(content) + ';expires=' + expireTime.toGMTString();
      if (domain) {
        cookie += ';path=/;domain=' + domain;
      }

      document.cookie = cookie;
      this.content = content;
    }
  }, {
    key: 'get',
    value: function get() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.key;

      var r = null;
      if (document.cookie.length > 0) {
        var cookieArray = document.cookie.split(';');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(cookieArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var cookie = _step.value;

            if (cookie.includes(key + '=')) {
              var temp = cookie.split('=');
              r = temp[1];
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return r;
    }
  }, {
    key: 'toString',
    value: function toString() {
      return this.key + '=' + this.content;
    }
  }], [{
    key: 'remove',
    value: function remove() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.key;
      var domain = arguments[1];

      if (document.cookie.length > 0) {
        var cookie = key + '=;expires=' + new Date(0).toGMTString();
        if (domain) {
          cookie += ';domain=' + domain;
        }
        document.cookie = cookie;
        this.content = null;
      }
    }
  }]);

  return cookieHandle;
}();

/* harmony default export */ __webpack_exports__["a"] = (cookieHandle);

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(557);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 566));
    },
    children: [{
      path: '',
      name: 'index',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 568));
      }
    }, {
      path: '/feedback',
      name: 'feedback',
      component: function component() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 565));
      }
    }]
  }, {
    path: '/login',
    name: 'login',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 567));
    }
  }]
}));

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gadgets_cookieHandler__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_env_conf__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_env_conf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_env_conf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);




var ENV = __WEBPACK_IMPORTED_MODULE_4__config_env_conf___default.a['test'];



var baseURL = '/rfInf/';
var axiosPOSTInstance = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({
  baseURL: baseURL
});

function _POST(_ref) {
  var dispatch = _ref.dispatch,
      commit = _ref.commit;
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var option = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return axiosPOSTInstance.post(url, params, option).then(function (res) {
    if (res.status === 200) {
      return toString.call(res.data) === '[object String]' ? JSON.parse(res.data) : res.data; // 返回
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
    }
  }).catch(function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
  });
}

function POST(_ref2) {
  var dispatch = _ref2.dispatch,
      commit = _ref2.commit;
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var option = arguments[3];

  return _POST({ dispatch: dispatch, commit: commit }, url, params, option).then(function (res) {
    if (res.code === '000000') {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res);
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
    }
  }).catch(function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    loginStatus: false,
    empGuid: null,
    empInfo: {}
  },
  mutations: {
    // Commit to change states
    IS_LOGIN: function IS_LOGIN(state) {
      state.loginStatus = true;
    },
    NOT_LOGIN: function NOT_LOGIN(state) {
      state.loginStatus = false;
    },
    HAS_LOGGED_OUT: function HAS_LOGGED_OUT(state) {
      state.loginStatus = null;
    },
    SET_GUID: function SET_GUID(state, empGuid) {
      state.empGuid = empGuid;
    },
    SET_EMP_INFO: function SET_EMP_INFO(state, emp) {
      state.empInfo = emp;
    }
  },
  actions: {
    // Dispatch to operate actions or commit mutation.
    /**************************
     *  检查 empGuid 是否存在  *
     **************************/
    CHECK_EMP_GUID: function CHECK_EMP_GUID(_ref3) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state;

      var _ref4 = new __WEBPACK_IMPORTED_MODULE_3__gadgets_cookieHandler__["a" /* default */]('EMPGUID'),
          content = _ref4.content;

      if (content) {
        commit('SET_GUID', content);
        commit('IS_LOGIN');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(content);
      } else {
        commit('NOT_LOGIN');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(null);
      }
    },


    /**********
     *  登录  *
     **********/
    LOGIN: function LOGIN(_ref5) {
      var dispatch = _ref5.dispatch,
          commit = _ref5.commit;

      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref6$countryCode = _ref6.countryCode,
          countryCode = _ref6$countryCode === undefined ? null : _ref6$countryCode,
          _ref6$userName = _ref6.userName,
          userName = _ref6$userName === undefined ? null : _ref6$userName,
          _ref6$userPwd = _ref6.userPwd,
          userPwd = _ref6$userPwd === undefined ? null : _ref6$userPwd,
          _ref6$empGuid = _ref6.empGuid,
          empGuid = _ref6$empGuid === undefined ? null : _ref6$empGuid;

      var url = '/adminLogin.shtml';
      var params = { countryCode: countryCode, userName: userName, userPwd: userPwd, empGuid: empGuid };

      return POST({ dispatch: dispatch, commit: commit }, url, params).then(function (data) {
        commit('IS_LOGIN');

        if (!empGuid) {
          // If login with userName and userPwd, mark down the empGuid
          var r = new __WEBPACK_IMPORTED_MODULE_3__gadgets_cookieHandler__["a" /* default */]('EMPGUID');
          r.set(data.empGuid + '', 30 * 24 * 60 * 60 * 1000, ENV['domain']); // 30 days
        }

        commit('SET_EMP_INFO', data);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
      }).catch(function (res) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
      });
    },
    LOGIN_NEW: function LOGIN_NEW(_ref7) {
      var dispatch = _ref7.dispatch,
          commit = _ref7.commit;

      var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref8$userName = _ref8.userName,
          userName = _ref8$userName === undefined ? null : _ref8$userName,
          _ref8$userPwd = _ref8.userPwd,
          userPwd = _ref8$userPwd === undefined ? null : _ref8$userPwd,
          _ref8$type = _ref8.type,
          type = _ref8$type === undefined ? null : _ref8$type;

      var url = '/adminCheckLogin.shtml';
      var params = { userName: userName, userPwd: userPwd, type: type };
      return POST({ dispatch: dispatch, commit: commit }, url, params);
    },


    /**********
     *  注销  *
     **********/
    LOGOUT: function LOGOUT(_ref9) {
      var dispatch = _ref9.dispatch,
          commit = _ref9.commit;

      __WEBPACK_IMPORTED_MODULE_3__gadgets_cookieHandler__["a" /* default */].remove('EMPGUID', ENV['domain']);
      commit('HAS_LOGGED_OUT');
    },


    /**************
     *  修改密码  *
     **************/
    EDIT_PASSWORD: function EDIT_PASSWORD(_ref10) {
      var dispatch = _ref10.dispatch,
          commit = _ref10.commit;

      var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          oldPwd = _ref11.oldPwd,
          newPwd = _ref11.newPwd,
          empGuid = _ref11.empGuid;

      var url = '/empModifyPwd.shtml';
      var params = { oldPwd: oldPwd, newPwd: newPwd, empGuid: empGuid };

      return POST({ dispatch: dispatch, commit: commit }, url, params);
    },


    /*****************
     *  获取用户信息  *
     *****************/
    GET_EMP_INFO: function GET_EMP_INFO(_ref12, mobile) {
      var dispatch = _ref12.dispatch,
          commit = _ref12.commit,
          state = _ref12.state;

      var url = '/getEmpInfo.shtml';
      var params = { mobile: mobile };

      return POST({ dispatch: dispatch, commit: commit }, url, params).then(function (data) {
        commit('SET_EMP_INFO', data);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
      }).catch(function (res) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
      });
    },


    /*****************
     *  用户能够访问POMP系统列表  *
     *****************/
    GET_POMP_PRIVILEGE_LIST: function GET_POMP_PRIVILEGE_LIST(_ref13, params) {
      var dispatch = _ref13.dispatch,
          commit = _ref13.commit,
          state = _ref13.state;

      var url = '/getPOMPPrivilegeList.shtml';
      return POST({ dispatch: dispatch, commit: commit }, url, params).then(function (data) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
      }).catch(function (res) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
      });
    },


    /**************
     *  获取国别号列表  *
     **************/
    GET_PM_COUNTRY_CODES: function GET_PM_COUNTRY_CODES(_ref14) {
      var dispatch = _ref14.dispatch,
          commit = _ref14.commit;

      var _ref15 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          empGuid = _ref15.empGuid;

      var url = '/getPmCountryCodes.shtml';
      var params = { empGuid: empGuid };

      return POST({ dispatch: dispatch, commit: commit }, url, params);
    },


    /**********
     *  企业微信扫码登录  *
     **********/
    QYWX_LOGIN: function QYWX_LOGIN(_ref16) {
      var dispatch = _ref16.dispatch,
          commit = _ref16.commit;

      var _ref17 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref17$code = _ref17.code,
          code = _ref17$code === undefined ? null : _ref17$code;

      var url = '/qyWxWebLogin.shtml';
      var params = { code: code };

      return POST({ dispatch: dispatch, commit: commit }, url, params).then(function (data) {
        commit('IS_LOGIN');

        var r = new __WEBPACK_IMPORTED_MODULE_3__gadgets_cookieHandler__["a" /* default */]('EMPGUID');
        r.set(data.empGuid + '', 30 * 24 * 60 * 60 * 1000, ENV['domain']); // 30 days

        commit('SET_EMP_INFO', data);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
      }).catch(function (res) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
      });
    },

    /**************
     *  获取意见反馈列表  *
     **************/
    GET_COMMENT_LIST: function GET_COMMENT_LIST(_ref18, params) {
      var dispatch = _ref18.dispatch,
          commit = _ref18.commit;

      var url = '/getCommentList.shtml';
      return POST({ dispatch: dispatch, commit: commit }, url, params);
    },
    GET_COMMENT_DETAIL: function GET_COMMENT_DETAIL(_ref19, params) {
      var dispatch = _ref19.dispatch,
          commit = _ref19.commit;

      var url = '/getCommentDetail.shtml';
      return POST({ dispatch: dispatch, commit: commit }, url, params);
    },
    COMMENT_ADD: function COMMENT_ADD(_ref20, params) {
      var dispatch = _ref20.dispatch,
          commit = _ref20.commit;

      var url = '/commentAdd.shtml';
      return POST({ dispatch: dispatch, commit: commit }, url, params);
    },
    COMMENT_ADDS: function COMMENT_ADDS(_ref21, params) {
      var dispatch = _ref21.dispatch,
          commit = _ref21.commit;

      var url = '/commentAdditional.shtml';
      return POST({ dispatch: dispatch, commit: commit }, url, params);
    },
    COMMENT_ADD_F: function COMMENT_ADD_F(_ref22, params) {
      var dispatch = _ref22.dispatch,
          commit = _ref22.commit;

      var url = '/commentAddByFile.shtml';
      return POST({ dispatch: dispatch, commit: commit }, url, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    COMMENT_ADDS_F: function COMMENT_ADDS_F(_ref23, params) {
      var dispatch = _ref23.dispatch,
          commit = _ref23.commit;

      var url = '/commentAdditionalByFile.shtml';
      return POST({ dispatch: dispatch, commit: commit }, url, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    COMMENT_FINISH: function COMMENT_FINISH(_ref24, params) {
      var dispatch = _ref24.dispatch,
          commit = _ref24.commit;

      var url = '/commentFinish.shtml';
      return POST({ dispatch: dispatch, commit: commit }, url, params);
    },
    GET_MODULE: function GET_MODULE(_ref25, params) {
      var dispatch = _ref25.dispatch,
          commit = _ref25.commit;

      var url = '/getCommentModuleList.shtml';
      return POST({ dispatch: dispatch, commit: commit }, url, params);
    }
  },
  getters: {
    // Get states statically
    isLogin: function isLogin(_ref26) {
      var loginStatus = _ref26.loginStatus;

      return !!loginStatus;
    },
    GUID: function GUID(_ref27) {
      var empGuid = _ref27.empGuid;

      return empGuid;
    },
    EMP_INFO: function EMP_INFO(_ref28) {
      var empInfo = _ref28.empInfo;

      return empInfo;
    }
  }
}));

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(541)
}
var Component = __webpack_require__(153)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(555),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(542)
}
var Component = __webpack_require__(153)(
  /* script */
  null,
  /* template */
  __webpack_require__(556),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 555:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "main-wrapper"
  }, [_c('router-view')], 1), _c('c-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-container"
  }, [_c('p', {
    staticClass: "footer-copyright"
  }, [_c('span', [_vm._v("CopyRight © 2019 ThinkinPower, ALL RIGHT RESERVED. ")]), _c('a', {
    attrs: {
      "href": "http://www.miitbeian.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备16101578号")]), (_vm.$env.env !== 'prod') ? _c('span', {
    staticClass: "env"
  }, [_vm._v(_vm._s(_vm.$env.name))]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(225);
module.exports = __webpack_require__(224);


/***/ })

},[561]);


// WEBPACK FOOTER //
// static/js/app.93edbdabffb8fb0015f2.js